export default "__VITE_ASSET__ZSx_n9PM__"